import { resetBillingState } from 'feature/billing/billingSlice';
import { resetClaims } from 'feature/claims/claimsSlice';
import { resetInputFilters, setSearch } from 'feature/form/formSlice';
import { resetTableSelection } from 'feature/tableSelectedItems/tableSelectedItemsSlice';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { AppDispatch, RootState } from 'store/store';
import { claimStatusIds } from 'types/Claims';
import {
	SERVICES_SHORT_TRANSLATION_KEY,
	TRANSLATION_KEYS,
} from 'utils/constants';
import { useTranslation } from 'utils/translations';

export const useGetClaimStatusProperty = () => {
	const { claimsStatuses } = useSelector((store: RootState) => store.form);

	const getClaimStatus = (statusId: claimStatusIds) => {
		return (
			claimsStatuses.find(el => el.id === statusId) || {
				id: 0,
				name: '',
				label: '',
				groupCode: '',
				groupLabel: '',
			}
		);
	};
	return {
		getClaimStatus,
	};
};
export const useGetServiceTypeInitials = () => {
	const { t: tDbLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.DB_LABELS,
	});

	const { servicesMap } = useSelector((state: RootState) => state.claim);

	const getInitialLabel = useCallback(
		(serviceType: string | undefined) => {
			if (!serviceType) {
				return '-';
			}

			const matching = servicesMap.find(
				service =>
					service.code.toLowerCase().replace('-', '') ===
					serviceType.toLowerCase().replace(' ', ''),
			);

			if (!matching) {
				return '-';
			}

			return tDbLabels(`${matching.label}.${SERVICES_SHORT_TRANSLATION_KEY}`);
		},
		[servicesMap, tDbLabels],
	);

	return {
		getInitialLabel,
	};
};

export const useResetPage = () => {
	const dispatch = useDispatch<AppDispatch>();
	const { pathname: currentPath } = useLocation();

	const currentPathStart = window.location.pathname.split('/')[1];
	const [prevPath, setPrevPath] = useState<string>(currentPathStart);

	useEffect(() => {
		return () => {
			const currentPathStart = window.location.pathname.split('/')[1];

			if (currentPathStart === prevPath) {
				return;
			}

			dispatch(resetInputFilters());
			dispatch(resetClaims());
			dispatch(resetTableSelection());
			dispatch(resetBillingState());
			dispatch(setSearch(false));

			setPrevPath(currentPathStart);
		};
	}, [currentPath, dispatch, prevPath]);
};
